import React from "react"
import { FaFacebookF, FaInstagram, FaYoutube, FaEnvelope } from "react-icons/fa"
import { motion } from "framer-motion"
import "./ContactPage.css"

const ContactPage = () => {
  return (
    <div className="contact-container">
      <h1 style={{ textAlign: 'center' }}>Contact Us</h1>
      {/* Social Icons Section */}
      <div className="footer-social" style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <div className="social-icons">
          <motion.a href="https://www.facebook.com/hennaandorganiccare" className="contact-icon" whileHover={{ scale: 1.1 }}>
            <FaFacebookF />
          </motion.a>
          <motion.a href="https://www.instagram.com/hennaandorganiccare/" className="contact-icon" whileHover={{ scale: 1.1 }}>
            <FaInstagram />
          </motion.a>
          <motion.a href="https://www.youtube.com/@Hennaandorganiccare" className="contact-icon" whileHover={{ scale: 1.1 }}>
            <FaYoutube />
          </motion.a>
          <motion.a href="mailto:esratjahanjyoti66@gmail.com" className="contact-icon" whileHover={{ scale: 1.1 }}>
            <FaEnvelope />
          </motion.a>
        </div>
      </div>
    </div>
  )
}

export default ContactPage
